import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-delete-property',
    templateUrl: './delete-property.component.html',
    styleUrls: ['./delete-property.component.css'],
    standalone: true,
    imports: [CommonModule, MatDialogModule, MatButtonModule]
})
export class DeletePropertyComponent implements OnInit {
  propertyName = inject(MAT_DIALOG_DATA);


  ngOnInit(): void {
  }

}
